// extracted by mini-css-extract-plugin
export var active = "_2x-9";
export var backButton = "_2x-8";
export var clone = "_2x-e";
export var collapseBar = "_2x-j";
export var collapseMode = "_2x-l";
export var collapsed = "_2x-n";
export var dragHandle = "_2x-c";
export var dropdownIcon = "_2x-g";
export var expanding = "_2x-m";
export var hidden = "_2x-v";
export var iconContainer = "_2x-p";
export var iconSwapper = "_2x-u";
export var navItem = "_2x-6";
export var navItemIcon = "_2x-f";
export var navProfile = "_2x-7";
export var notificationCountBadge = "_2x-i";
export var notificationDot = "_2x-q";
export var optionsContainer = "_2x-h";
export var primaryNav = "_2x-0";
export var primaryNavDivider = "_2x-t";
export var primaryNavResizeHandle = "_2x-2";
export var primaryNavResizing = "_2x-1";
export var primaryTab = "_2x-o";
export var primaryTabIconBox = "_2x-r";
export var secondaryNav = "_2x-3";
export var selected = "_2x-s";
export var settingsNav = "_2x-4";
export var settingsNavItems = "_2x-5";
export var show = "_2x-d";
export var sideNav = "_2x-k";
export var teamItem = "_2x-a";
export var userProfileItem = "_2x-b";